import { render, staticRenderFns } from "./CreateAPIKeysForm.vue?vue&type=template&id=1d974a88&scoped=true&"
import script from "./CreateAPIKeysForm.vue?vue&type=script&lang=js&"
export * from "./CreateAPIKeysForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateAPIKeysForm.vue?vue&type=style&index=0&id=1d974a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d974a88",
  null
  
)

export default component.exports